﻿window.cBuilderEmailWidgetColonne = function (option) {
    var Me = this

    if (typeof option.nbCol == 'undefined' && option.element != 'undefined') option.nbCol = option.element.attr("nbcol")

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetcolonne' nbcol='" + option.nbCol + "'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>" + (option.nbCol == 1 ? "Bloc" : option.nbCol + " colonnes") + "</div>").appendTo($DivBt)
        if (option.nbCol == 1) {
            $DivBt.attr("title", "Ajouter un widget « Bloc » qui vous permet de créer un bloc et d’y ajouter plusieurs widgets à l’intérieur.")
        } else {
        $DivBt.attr("title", "Ajouter un widget avec " + option.nbCol + " colonnes où vous pouvez rajouter des widgets dans chacune des colonnes")
        }

        return $DivBt
    }

    this.mCreateElement = function () {
        var percentForWidth = 100 / option.nbCol // Math.floor(100 / option.nbCol)
        var delta = 0 //100 - (percentForWidth * option.nbCol)
        option.element = $("<tr class='widget dxwidgetcolonne' nbcol='" + option.nbCol + "'>")
        $("<!-- DEBUT COLONNE " + option.nbCol + " -->").appendTo(option.element)
        var $Td = $("<td style='padding: 0px;' class='bodywidget tdwidget tdwidgetcolonne widgetheightauto'>").appendTo(option.element)
        $Td.attr("jsoncssdatawidget", JSON.stringify({}))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)

        var $Table = $("<table align='center' cellspacing='0' cellpadding='0' border='0' style='width: 100%;'>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($Table)
        for (var i = 1; i <= option.nbCol; i++) {
            var percentWidthCol = percentForWidth
            if (i == option.nbCol) { percentWidthCol = percentForWidth + delta }
            var $TdCol = $("<td class='tdcol' valign='top' style='padding: 0px;width:" + percentWidthCol + "%;' colwidthpercent='" + percentWidthCol + "' numcol='" + i + "'>").appendTo($Tr)
            var $Table = $("<table class='acceptwidget col" + i + " colonne tablewidget' valign='top' align='center' cellspacing='0' cellpadding='0' border='0' style='width: 100%;' width='100%' numcol='" + i + "'>").appendTo($TdCol)
        }
        $("<!-- FIN COLONNE " + option.nbCol + " -->").appendTo(option.element)
        mAddRemoveWidgetVide()
    }

    this.nom = (option.nbCol == 1 ? "Bloc" : option.nbCol + "Colonnes")
    this.icone = (option.nbCol == 1 ? "fas fa-window-maximize" : "fas fa-table-columns")

    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()

        if (option.nbCol > 1) {
            //$("<br/>").appendTo(contentElement)
            $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Taille colonne:</div>").appendTo(contentElement)
            $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleColonneTaille({
                value: option.element,
                onValueChanged: option.onValueChanged
            })
        }
    }

    function mAddRemoveWidgetVide() {
        option.element.find(".colonne").each(function (idx, ele) {
            if ($(ele).find(".widget").length == 0) {
                mAddWidgetVide($(ele))
            } else if ($(ele).find(".widget").length > 1) {
                if ($(ele).find(".dxwidgetvide").length > 0) {
                    $($(ele).find(".dxwidgetvide")).remove()
                }
            }
        })

        function mAddWidgetVide(ele) {
            var widgetVide = new cBuilderEmailWidget({
                bddCtrl: option.bddCtrl,
                typeWidget: "dxwidgetvide",
                dxBuilderEmailPage: option.dxBuilderEmailPage
            })
            widgetVide.option("element").appendTo(ele)
        }
    }

    this.mUpdateCss = function () {
        mAddRemoveWidgetVide()
        option.element.find(".tdcol").each(function (idx, ele) {
            var percent = $(ele).attr("colwidthpercent")
            $(ele).css("width", percent + "%")
        })
    }

    this.mGetInnerWidthColonne = function (idCol) {
        var widthPercent = parseInt(option.element.find(".col" + idCol).parent().attr("colwidthpercent").replace("%", ""))
        return this.mGetInnerWidthBloc() * widthPercent / 100
    }

    this.mGetInnerWidthBloc = function () {
        var widthPaddingBorderBloc = option.parent.mGetTotalWidthPaddingEtBorder()
        var widthPage = option.dxBuilderEmailPage.mGetWidthPage()
        return widthPage - widthPaddingBorderBloc
    }

    //function mGetTailleColonne(idxColonne) {
    //    var marge = option.parent.mGetTotalWidthPaddingEtBorder()
    //    var taillePage = option.dxBuilderEmailPage.$TableMessage.css("max-width").replace("px", "") * 1
    //    var percent = $(option.element.find(".col" + idxColonne)).attr("colwidthpercent")
    //    taillePage = taillePage - marge
    //    return taillePage * percent / 100
    //}

}